import dropdownConstants from '../../constants';
import computeClassName from '../../../../../../../utils/computeClassName';
import CCIconCheck12x12 from '../../../../Icon/Check/12x12';
import handleClick from "../../../../../../../utils/handleClick";

const constants = Object.freeze({
  CLASSNAME_BASE: 'transition-colors duration-100 ease-linear',
  CLASSNAME_IS_DISABLED: {
    true: 'text-cc-muted-contrast',
    false: 'cursor-pointer hover:bg-cc-accent-0 hover:text-cc-accent'
  },
  CLASSNAME_IS_SELECTED: {
    true: 'font-semibold',
    false: ''
  },
  CLASSNAME_DROPDOWN_SIZE: Object.fromEntries(
    new Map([
      [dropdownConstants.SIZE_XSMALL, 'px-2 py-1'],
      [dropdownConstants.SIZE_SMALL, 'px-3 py-1.25'],
      [dropdownConstants.SIZE_MEDIUM, 'px-4 py-1.25'],
      [dropdownConstants.SIZE_LARGE, 'px-4 py-1.5']
    ])
  ),
  CLASSNAME_DROPDOWN_IS_LTR: {
    true: 'text-left',
    false: 'text-right'
  },


  CLASSNAME_CHECK_BASE: 'transition-colors duration-100 ease-linear',
  CLASSNAME_CHECK_DROPDOWN_SIZE: Object.fromEntries(
    new Map([
      [dropdownConstants.SIZE_XSMALL, 'w-2 h-2'],
      [dropdownConstants.SIZE_SMALL, 'w-2 h-2'],
      [dropdownConstants.SIZE_MEDIUM, 'w-3 h-3'],
      [dropdownConstants.SIZE_LARGE, 'w-3 h-3']
    ])
  ),
  CLASSNAME_CHECK_DROPDOWN_OPTION_IS_DISABLED: {
    true: 'text-cc-muted-contrast',
    false: 'group-hover:text-cc-accent'
  },

  CLASSNAME_CHECKBOX_BASE: 'block rounded',

  CLASSNAME_CHECKBOX_DROPDOWN_OPTION_IS_SELECTED: {
    true: {
      DROPDOWN_OPTION_IS_DISABLED: {
        true: {
          DROPDOWN_SIZE: Object.fromEntries(
            new Map([
              [dropdownConstants.SIZE_XSMALL, 'flex-shrink-0 w-3 h-3 bg-cc-gray-60 text-cc-white bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_SMALL, 'flex-shrink-0 w-4 h-4 bg-cc-gray-60 text-cc-white bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_MEDIUM, 'flex-shrink-0 w-4 h-4 bg-cc-gray-60 text-cc-white bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_LARGE, 'flex-shrink-0 w-5 h-5 bg-cc-gray-60 text-cc-white bg-cc-icon-check-medium bg-center bg-no-repeat']
            ])
          ),
        },
        false: {
          DROPDOWN_SIZE: Object.fromEntries(
            new Map([
              [dropdownConstants.SIZE_XSMALL, 'flex-shrink-0 w-3 h-3 bg-cc-accent text-cc-accent-contrast bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_SMALL, 'flex-shrink-0 w-4 h-4 bg-cc-accent text-cc-accent-contrast bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_MEDIUM, 'flex-shrink-0 w-4 h-4 bg-cc-accent text-cc-accent-contrast bg-cc-icon-check-small bg-center bg-no-repeat'],
              [dropdownConstants.SIZE_LARGE, 'flex-shrink-0 w-5 h-5 bg-cc-accent text-cc-accent-contrast bg-cc-icon-check-medium bg-center bg-no-repeat']
            ])
          )
        }
      },
    },
    false: {
      DROPDOWN_OPTION_IS_DISABLED: {
        true: {
          DROPDOWN_SIZE: Object.fromEntries(
            new Map([
              [dropdownConstants.SIZE_XSMALL, 'flex-shrink-0 w-3 h-3 border border-cc-gray-40 bg-cc-gray-05 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_SMALL, 'flex-shrink-0 w-4 h-4 border border-cc-gray-40 bg-cc-gray-05 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_MEDIUM, 'flex-shrink-0 w-4 h-4 border border-cc-gray-40 bg-cc-gray-05 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_LARGE, 'flex-shrink-0 w-5 h-5 border border-cc-gray-40 bg-cc-gray-05 transition-colors duration-100 ease-linear group-hover:border-cc-accent']
            ])
          ),
        },
        false: {
          DROPDOWN_SIZE: Object.fromEntries(
            new Map([
              [dropdownConstants.SIZE_XSMALL, 'flex-shrink-0 w-3 h-3 border border-cc-gray-40 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_SMALL, 'flex-shrink-0 w-4 h-4 border border-cc-gray-40 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_MEDIUM, 'flex-shrink-0 w-4 h-4 border border-cc-gray-40 transition-colors duration-100 ease-linear group-hover:border-cc-accent'],
              [dropdownConstants.SIZE_LARGE, 'flex-shrink-0 w-5 h-5 border border-cc-gray-40 transition-colors duration-100 ease-linear group-hover:border-cc-accent']
            ])
          )
        },
      }
    }
  }
});

function getComputedClassName(propsClassName, dropdownSize, dropdownIsLTR, dropdownOptionIsSelected, dropdownOptionIsDisabled, dropdownOptionIsGroup) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE} ${constants.CLASSNAME_DROPDOWN_SIZE[dropdownSize]} ${constants.CLASSNAME_DROPDOWN_IS_LTR[dropdownIsLTR]} ${constants.CLASSNAME_IS_DISABLED[dropdownOptionIsDisabled]} ${constants.CLASSNAME_IS_SELECTED[dropdownOptionIsSelected]}`);
}

function getComputedCheckClassName(propsClassName, dropdownOptionIsDisabled, dropdownSize) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_CHECK_BASE} ${constants.CLASSNAME_CHECK_DROPDOWN_OPTION_IS_DISABLED[dropdownOptionIsDisabled]} ${constants.CLASSNAME_CHECK_DROPDOWN_SIZE[dropdownSize]}`);
}

function getComputedCheckboxClassName(className, dropdownSize, dropdownOptionIsSelected, dropdownOptionIsDisabled) {
  return computeClassName(className, `${constants.CLASSNAME_CHECKBOX_BASE} ${constants.CLASSNAME_CHECKBOX_DROPDOWN_OPTION_IS_SELECTED[dropdownOptionIsSelected].DROPDOWN_OPTION_IS_DISABLED[dropdownOptionIsDisabled].DROPDOWN_SIZE[dropdownSize]}`)
}

export default function CCFormDropdownOptionsOption(
  {
    dropdownOption,
    dropdownAllowMultipleSelection,
    dropdownSize,
    dropdownOptionKeyLabel,
    dropdownOptionKeyValue,
    dropdownOptionKeyIsDisabled,
    dropdownOptionKeyIsGroup,
    dropdownOptionKeyIsSelected,
    dropdownOptionSelectFn,
    dropdownOptionUnselectFn,
    dropdownIsLTR,
    className = ''
  }
) {
  const dropdownOptionIsSelected = dropdownOptionKeyIsSelected in dropdownOption ? dropdownOption[dropdownOptionKeyIsSelected] : false;
  const dropdownOptionIsDisabled = dropdownOptionKeyIsDisabled in dropdownOption ? dropdownOption[dropdownOptionKeyIsDisabled] : false;
  const dropdownOptionIsGroup = dropdownOptionKeyIsGroup in dropdownOption ? dropdownOption[dropdownOptionKeyIsGroup] : false;

  const computedClassName = getComputedClassName(className, dropdownSize, dropdownIsLTR, dropdownOptionIsSelected, dropdownOptionIsDisabled, dropdownOptionIsGroup);
  const computedCheckClassName = getComputedCheckClassName('', dropdownOptionIsDisabled, dropdownSize);
  const computedCheckboxClassName = getComputedCheckboxClassName('', dropdownSize, dropdownOptionIsSelected, dropdownOptionIsDisabled);
  let dynamicProps = {};
  if(!dropdownOptionIsDisabled && !dropdownOptionIsGroup) {
    dynamicProps['onClick'] = handleClick(dropdownOptionIsSelected  ? dropdownOptionUnselectFn : dropdownOptionSelectFn, dropdownOption);
    dynamicProps['tab-index']="0";
    dynamicProps['role']="option"
    if(dropdownOptionIsSelected) {
      dynamicProps['aria-selected'] = "true";
    }
    else {
      dynamicProps['aria-selected'] = "false";
    }
  }
  return (
    <li className={computedClassName} {...dynamicProps}>
      {
        dropdownOptionIsSelected ?
          <span className="group flex items-center space-x-3">
            {
              dropdownAllowMultipleSelection ?
                <>
                  <span className={computedCheckboxClassName}/>
                  <span className="flex-grow">{dropdownOption[dropdownOptionKeyLabel]}</span>
                </> :
                <>
                  <span className="flex-grow">{dropdownOption[dropdownOptionKeyLabel]}</span>
                  <CCIconCheck12x12 className={computedCheckClassName} />
                </>
            }
          </span> :
          <span className="group flex items-center space-x-3">
            {
              dropdownAllowMultipleSelection ?
                <>
                  <span className={computedCheckboxClassName}/>
                  <span className="flex-grow">{dropdownOption[dropdownOptionKeyLabel]}</span>
                </> :
                <span>{dropdownOption[dropdownOptionKeyLabel]}</span>
            }
          </span>
      }
    </li>
  );
}


